import React from 'react'
import { components } from 'react-select'

class Option extends React.Component { 
	render () {
		return <components.Option {...this.props}>
			{this.props.children}
		</components.Option>
	}
}
export default Option